var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    fill: "#151522"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    fill: "url(#paint0_linear_698_10686)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    fill: "url(#paint1_linear_698_10686)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    fill: "url(#paint2_linear_698_10686)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    fill: "url(#paint3_linear_698_10686)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    stroke: "url(#paint4_linear_698_10686)",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    stroke: "url(#paint5_linear_698_10686)",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5741 2.94643C7.91827 2.94643 3.33333 7.53137 3.33333 13.1872C3.33333 18.843 7.91827 23.4279 13.5741 23.4279C16.3406 23.4279 18.8508 22.3309 20.6936 20.5482C20.7273 20.503 20.7646 20.4597 20.8056 20.4187C20.8466 20.3777 20.8899 20.3404 20.9351 20.3067C22.7178 18.4639 23.8148 15.9537 23.8148 13.1872C23.8148 7.53137 19.2299 2.94643 13.5741 2.94643ZM23.2521 21.2153C25.0607 19.0375 26.1481 16.2393 26.1481 13.1872C26.1481 6.2427 20.5185 0.613098 13.5741 0.613098C6.6296 0.613098 1 6.2427 1 13.1872C1 20.1316 6.6296 25.7612 13.5741 25.7612C16.6262 25.7612 19.4244 24.6738 21.6022 22.8652L27.0084 28.2714C27.464 28.727 28.2027 28.727 28.6583 28.2714C29.1139 27.8158 29.1139 27.0771 28.6583 26.6215L23.2521 21.2153Z",
    stroke: "url(#paint6_linear_698_10686)",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_10686",
    x1: 2.13054,
    y1: 14.4726,
    x2: 27.8932,
    y2: 14.4726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_698_10686",
    x1: 15,
    y1: 0.613098,
    x2: 15,
    y2: 28.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C258D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4389A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_698_10686",
    x1: 15,
    y1: 0.613098,
    x2: 15,
    y2: 28.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E22CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F46E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_698_10686",
    x1: 15,
    y1: 0.613098,
    x2: 15,
    y2: 28.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A569D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_698_10686",
    x1: 15,
    y1: 0.613098,
    x2: 15,
    y2: 28.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_698_10686",
    x1: 15,
    y1: 0.613098,
    x2: 15,
    y2: 28.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E22CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F46E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_698_10686",
    x1: 15,
    y1: 0.613098,
    x2: 15,
    y2: 28.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A569D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2424"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.78fc20cd41f3e1767110971a5012c5db.svg";
export { ForwardRef as ReactComponent };